import { type FC } from 'react';
import { type ResourceTypeText } from '@common/types/resource';
import { resourceImages } from '@components/helpers/imagesImports';
import cn from 'classnames';

interface MineImageProps {
  resourceName: ResourceTypeText;
  className?: string;
}

const MineImage: FC<MineImageProps> = ({ className, resourceName }) => {
  const img = resourceImages[resourceName].mine;

  return (
    <div className={cn('aspect-square', className)}>
      <picture className="h-full">
        <source className="w-full h-full" srcSet={img.webp} type="image/webp" />
        <img className="w-full h-full" src={img.png} alt="mine" />
      </picture>
    </div>
  );
};

export { MineImage };
